@if (freeTrialProperties$ | async; as freeTrialProperties) {
  <div class="free-trial-container">
    <mat-card class="free-trial-card">
      <mat-card-title class="free-trial-header">
        <div>Trial Administration</div>
        <div class="action-buttons-container">
          @if (isExtendButtonAvailable(freeTrialProperties)) {
            <button mat-button (click)="showExtendConfirmationPopup()"
              class="mat-raised-button mat-primary extend-button">Extend
            </button>
          }
          @if (isReactivateButtonAvailable(freeTrialProperties)) {
            <button mat-button (click)="showReactivateConfirmationPopup()"
              class="mat-raised-button mat-accent">Reactivate
            </button>
          }
          @if (isUpgradeButtonAvailable(freeTrialProperties)) {
            <button mat-button
              (click)="showUpgradeConfirmationPopup()" class="mat-raised-button mat-primary">Upgrade to Paid Tenant
            </button>
          }
          @if (isCancelButtonAvailable(freeTrialProperties)) {
            <button mat-button (click)="showCancelConfirmationPopup()"
            class="mat-raised-button mat-warn">Cancel Trial</button>
          }
        </div>
      </mat-card-title>
      <mat-divider></mat-divider>
      <form [formGroup]="freeTrialForm" class="free-trial-form">
        <div class="free-trial-property">
          <div class="free-trial-status">Status: <span [class]="getTrialStatusClass(freeTrialProperties)">{{
          freeTrialProperties.TrialStatus }}</span></div>
        </div>
        <div class="free-trial-property">
          <mat-form-field id="trial-type-field">
            <mat-label>Trial Type</mat-label>
            <input matInput formControlName="trialType">
          </mat-form-field>
        </div>
        <div class="free-trial-property">
          <mat-form-field id="trial-start-date-field">
            <mat-label>Trial Start Date</mat-label>
            <input matInput [matDatepicker]="trialStartDatePicker" formControlName="trialStartDate" />
            <mat-datepicker-toggle matSuffix [for]="trialStartDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #trialStartDatePicker disalbed></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="free-trial-property">
          <mat-form-field id="trial-expiry-date-field">
            <mat-label>Trial Expiry Date</mat-label>
            <input matInput [matDatepicker]="trialExpiryDatePicker" [min]="freeTrialProperties.TrialStartDate"
              [max]="getMaxExpiryDate(freeTrialProperties.TrialStartDate)" formControlName="trialEndDate" />
            <mat-datepicker-toggle matSuffix [for]="trialExpiryDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #trialExpiryDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        @if (!isTrialPromoted(freeTrialProperties)) {
          <div class="free-trial-property">
            <mat-form-field id="trial-remaining-days-field">
              <mat-label>Trial Remaining Days</mat-label>
              <input disabled matInput [value]="getRemainingDays()">
            </mat-form-field>
          </div>
        }
        @if (isTrialPromoted(freeTrialProperties)) {
          <div class="free-trial-property">
            <mat-form-field id="trial-promoted-date-field">
              <mat-label>Trial Promoted Date</mat-label>
              <input matInput [matDatepicker]="trialPromotedDatePicker" formControlName="trialPromotedDate" />
              <mat-datepicker-toggle matSuffix [for]="trialPromotedDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #trialPromotedDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        }
        @if (isSaveChangesButtonAvailable(freeTrialProperties)) {
          <button mat-button (click)="saveTrialChanges()"
            [disabled]="freeTrialForm.pristine || !freeTrialForm.valid" class="mat-raised-button mat-accent">
            Save changes
          </button>
        }
      </form>
    </mat-card>
  </div>
}